import React from 'react'

function StarFilled() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="22" viewBox="0 0 24 22" fill="none">
      <path d="M12 0.166992L8.58752 7.08199L0.960022 8.18449L6.48002 13.5695L5.17502 21.167L12 17.582L18.825 21.167L17.52 13.5695L23.04 8.19199L15.4125 7.08199L12 0.166992Z" fill="#161616"/>
    </svg>
  )
}

export default StarFilled
